import { OptionItem } from "commons/ultilities/dynamic-form/models/control";

import { DEFAULT_CATALOG_SLICE_SIZE } from "commons/constants";
import { createMaterialOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import {
  IAddMaterial,
  IMaterialProperties,
  IUpdateMaterial,
} from "mobx-stores/_models/material-inventory/material";
import { BaseBussiness } from "../base";

class MaterialBusiness extends BaseBussiness<
  IMaterialProperties,
  IAddMaterial,
  IUpdateMaterial,
  IMaterialProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public searchMaterialsAsOptionItems = async (keyword: string) => {
    const materials = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });
    return mapToDistinctOptionItems(
      materials.items,
      (x) => x.id,
      (x) => createMaterialOptionLabel(x),
    );
  };

  public searchMaterialCodeOptions = async (
    keyword: string,
  ): Promise<OptionItem[]> => {
    const result = await materialBusiness.getLists({
      code: keyword || undefined,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });
    return mapToDistinctOptionItems(
      (result.items ?? []).filter((item) => !!item.code),
      (item) => item.code,
    );
  };

  public searchMaterialTypeOptions = async (
    keyword: string,
  ): Promise<OptionItem[]> => {
    const result = await materialBusiness.getLists({
      type: keyword || undefined,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });
    return mapToDistinctOptionItems(
      (result.items ?? []).filter((item) => !!item.type),
      (item) => item.type,
    );
  };

  public searchMaterialNameOptions = async (
    keyword: string,
  ): Promise<OptionItem[]> => {
    const result = await materialBusiness.getLists({
      name: keyword || undefined,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });
    return mapToDistinctOptionItems(
      (result.items ?? []).filter((item) => !!item.name),
      (item) => item.name,
    );
  };
}

export const materialBusiness = new MaterialBusiness("/api/app/material");
